import React from "react";
import styled from "styled-components";
import { FaDownload } from "react-icons/fa";

// Styled components
const DownloadButton = styled.button`
    padding: 10px;
    font-size: 16px;
    background-color: #3498db;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
`;

export default function DownloadCSVFile() {
    const handleDownload = () => {
        // Path to the CSV file in the public folder
        const filePath = "./ZBIZFILE.csv";

        // Create an anchor element
        const link = document.createElement("a");

        // Set the href attribute to the file path
        link.href = filePath;

        // Specify the download attribute along with the desired file name
        link.download = "downloaded-file.csv";

        // Simulate a click on the anchor element to trigger the download
        document.body.appendChild(link);
        link.click();

        // Remove the anchor element from the DOM
        document.body.removeChild(link);
    };

    return (
        <div style={{ lineHeight: "6", textAlign: "right" }}>
            <DownloadButton onClick={handleDownload}>
                <FaDownload style={{ marginRight: "5px" }} />
                Download CSV File
            </DownloadButton>
        </div>
    );
}
